import UIGenerator from './UIGen';
import HeatCell from './heatCell';
const Heatmap = function (containerID, cols, rows, colors) {
  this.active = true;
  this.uiGen = new UIGenerator('');
  this.container = document.querySelector(`#${containerID}`);

  if (this.container.children('.heatmap_element').length > 0) {
    this.active = false;
    return;
  }
  this.cols = cols;
  this.rows = rows;
  this.colors = colors;

  this.cells = [];

  this.generateElement();
};

Heatmap.prototype.initCells = function () {
  let currentRow;
  for (let i = 0; i < this.rows; i++) {
    currentRow = this.uiGen.generateAndAddHTML(this.element, {
      type: 'tr',
      attributes: {
        class: 'heatmap_table_row',
      },
    });
    for (let j = 0; j < this.cols; j++) {
      if (!this.cells[j]) {
        this.cells[j] = [];
      }
      this.cells[j][i] = new HeatCell(currentRow, j, i, this.colors, this.uiGen);
    }
  }
};

Heatmap.prototype.generateElement = function () {
  this.element = this.uiGen.generateAndAddHTML(this.container, {
    type: 'table',
    attributes: {
      class: 'heatmap_element',
    },
  });

  this.middline = this.uiGen.generateAndAddHTML(this.container, {
    attributes: {
      class: 'heatmap_middline',
    },
  });

  this.initCells();
};

Heatmap.prototype.update = function (newData) {
  if (!this.active) {
    return;
  }
  let currentData;
  for (const index in newData) {
    currentData = newData[index];
    this.cells[currentData.x][currentData.y].update(currentData.data);
  }
};

export default Heatmap;
